module.exports = __webpack_public_path__ + "img/time.9d9a4ee8.svg";